import clsx from 'clsx';
import { useMemo } from 'react';

import styles from './styles.module.scss';

type InputProps = {
  submitted: number;
  needed: number;
};

export const OnboardingDocs = ({ submitted, needed }: InputProps) => {
  const isFull = useMemo(() => {
    return !(needed - submitted);
  }, [submitted, needed]);
  return (
    <div className={styles.root}>
      <div className={styles.title}>Compliance Docs</div>
      <div className={clsx(styles.info, isFull && styles.blue)}>
        <b>{submitted}</b> of <b>{needed}</b> Docs Submitted
      </div>
    </div>
  );
};
